const DeleteWatchlistModal = props => {

    const s = props.singular ? '' : 's';

    return <div className='popup' onClick={() => props.close()}>
        <div className='popup-inner merge delete' onClick={e => e.stopPropagation()}>
            <div className='header'>
                <div className='title'>Delete Watchlist{s}</div>
                <button onClick={() => props.close()} className="close-cross" aria-label="close modal" />
            </div>
            <p>Are you sure you want to delete the watchlist{s}?</p>
            <label>Once a watchlist is deleted it cannot be restored.</label>
            <div className="inline-list">
                <button className="button danger" disabled={props.disabled} onClick={() => props.delete()} style={{ marginRight: 0 }}>Yes</button>
                <button className="button secondary" disabled={props.disabled} onClick={() => props.close()}>Cancel</button>
            </div>
        </div>
    </div>
}

export default DeleteWatchlistModal;
